/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 *
 * See: https://github.com/zloirock/core-js#babel
 */

import 'core-js/stable';
import 'regenerator-runtime/runtime';

// NOTE: This is a workaround for the Node.js crypto package that is currently being used (in future this should be replaced with a browser supported package)
(window as any).global = window;